import { render, staticRenderFns } from "./consult.vue?vue&type=template&id=563fac7a&scoped=true&"
import script from "./consult.vue?vue&type=script&lang=js&"
export * from "./consult.vue?vue&type=script&lang=js&"
import style0 from "./consult.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./consult.vue?vue&type=style&index=1&id=563fac7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563fac7a",
  null
  
)

export default component.exports